const buildOptionalPubQuery = (pubId) => pubId ? `?pub_id=${encodeURIComponent(pubId)}` : "";
export const API_ENDPOINTS = {
    AUTH: {
        MENU_TOKEN_LOGIN: (token) => `/api/v1/rbzo/auth/menu-token-login?token=${encodeURIComponent(token)}`,
        LOGOUT: "/api/v1/rbzo/auth/logout",
    },
    USERS: {
        PROFILE: "/api/v1/rbzo/user/profile",
        SECURE_LOGIN: "/api/v1/rbzo/users/secure-login",
        SEND_OTP: "/api/v1/rbzo/users/sendOtp",
        GET_CUSTOMER: (phoneNumber) => `/api/v1/rbzo/users/getCustomer?phoneNumber=${encodeURIComponent(phoneNumber)}`,
        VERIFY_OTP: (uid, otp) => `/api/v1/rbzo/users/verifyOtp?uid=${encodeURIComponent(uid)}&otp=${encodeURIComponent(otp)}`,
    },
    WALLET: {
        FETCH_DETAILS: (userId, pubId) => `/api/v1/rbzo/wallet/${userId}/fetchDetails${buildOptionalPubQuery(pubId)}`,
        USER_COUPONS: (userId, pubId) => `/api/v1/rbzo/wallet/${userId}/coupons${buildOptionalPubQuery(pubId)}`,
        COVER_BY_UUID: (coverUuid) => `/api/v1/rbzo/wallet/${coverUuid}/coverDetails`,
        COVER_DETAILS: (userId, eventId, code) => `/api/v1/rbzo/wallet/coverDetails?user_id=${userId}&event_id=${eventId}&code=${code}`,
    },
    BOOKINGS: {
        USER_BOOKINGS: (userId, page = 0, size = 5, pubId) => {
            const baseQuery = `?page=${page}&size=${size}`;
            const pubQuery = pubId ? `&pub_id=${encodeURIComponent(pubId)}` : "";
            return `/api/v1/rbzo/users/${userId}/bookings${baseQuery}${pubQuery}`;
        },
    },
    PUBS: {
        CHAINS: {
            LIST_PUBS: (chainId) => `/api/v1/rbzo/pubs/chains/listPubs?chainId=${chainId}`,
        },
    },
};
export default API_ENDPOINTS;
